import axios   from 'axios'
import config  from '@/config'
import $log    from '@/utils/log'
import $time   from '@/utils/time'

export default {


  // This method counts our events before fetching them
  // See: back/src/api/event/controllers/event.js

  count( time ) {
    $log.info( `API`, `Counting events.` )
    let filters
    if ( time == 'past' ) {
      filters = {
        ends: {
          $lt: $time.now()
        },
        show_in_archive: {
          $eq: true,
        }
      }
    } else {
      filters = {
        ends: {
          $gte: $time.now(),
        },
        show_in_agenda: {
          $eq: true,
        }
      }
    }
    return new Promise( ( resolve, reject ) => {
      axios
      .post( `${ config.api_url }/events/count/password`, { params: { filters } } )
      .then( result => resolve( result.data ) )
      .catch( error => {
        $log.error( 'API', error )
        reject( error )
      } )
    } )
  },


  // Fetch all events; sort in reverse chronological
  // order (i.e. most recent event first).

  getPast() {
    $log.info( `API`, `Fetching past events.` )
    return new Promise( ( resolve, reject ) => {
      axios
      .get( `${ config.api_url }/events`, { params: {
        sort: 'starts:asc',
        filters: {
          ends: {
            $lt: $time.now()
          },
          show_in_archive: {
            $eq: true,
          }
        },
        fields: [
          'title',
          'slug',
          'starts',
          'ends',
          'background_color',
          'accent_color',
          'text_color',
          'text_outline',
          'info', 
          'mux_recording',
          'password_protected'
        ],
        populate: [
          'font',
          'font.file',
          'background_image',
          'organisation',
          'organisation.Logo',
        ],
        pagination: {
          pageSize: 100,
        }
      } } )
      .then( result => resolve( result.data.data ) )
      .catch( error => {
        $log.error( 'API', error )
        reject( error )
      } )
    } )
  },


  // Fetch futuer events; sort in reverse chronological
  // order (i.e. most recent event first).

  getFuture() {
    $log.info( `API`, `Fetching future events.` )
    return new Promise( ( resolve, reject ) => {
      axios
      .get( `${ config.api_url }/events`, { params: {
        sort: 'starts:desc',
        filters: {
          ends: {
            $gte: $time.now(),
          },
          show_in_agenda: {
            $eq: true,
          }
        },
        fields: [
          'title',
          'slug',
          'starts',
          'ends',
          'background_color',
          'accent_color',
          'text_color',
          'text_outline',
          'info',
          'password_protected',
          'mux_recording',
          'show_in_agenda',
        ],
        populate: [
          'font',
          'font.file',
          'background_image',
          'organisation',
          'organisation.Logo',
          'livestream',
        ],
        pagination: {
          pageSize: 100,
        }
      } } )
      .then( result => resolve( result.data.data ) )
      .catch( error => {
        $log.error( 'API', error )
        reject( error )
      } )
    } )
  },


  // Fetch event by slug. Non-standard implementation
  // See: back/src/api/event/controllers/event.js

  get({ slug, password }) {
    $log.info( `API`, `Fetching event ${ slug }.` )
    return new Promise( ( resolve, reject ) => {
      axios
      .post(
        `${ config.api_url }/events/${ slug }/password`, { 
        password,
        params: {
          fields: '*',
          populate: [
            'viewers',
            'font',
            'font.file',
            'background_image',
            'emoji_groups',
            'emoji_groups.emoji',
            'emoji_groups.emoji.image',
            'organisation',
            'organisation.Logo',
          ]
        }
      } )
      .then( result => resolve( result.data.data ) )
      .catch( error => {
        $log.error( 'API', error )
        reject( error )
      } )
    } )
  },


  // Log event visit in custom strapi route /log-visit

  log_visit( slug ) {
    $log.info( `API`, `Logging visit for event ${ slug }.` )
    return new Promise( ( resolve, reject ) => {
      axios
      .patch( `${ config.api_url }/events/${ slug }/visit` )
      .then( result => resolve( result.data ) )
      .catch( error => {
        $log.error( 'API', error )
        reject( error )
      } )
    } )
  },


}
